(function () {
  'use strict';

  /* ---------- Navegación móvil ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var menuOverlay = document.querySelector('[data-menu-overlay]');

  function toggleMobileNav() {
    if (!mobileNav) return;
    var isOpen = mobileNav.classList.toggle('is-open');
    if (menuOverlay) menuOverlay.classList.toggle('is-open', isOpen);
    mobileNav.setAttribute('aria-hidden', String(!isOpen));
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }

  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', toggleMobileNav);
  });

  if (menuOverlay) menuOverlay.addEventListener('click', toggleMobileNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileNav && mobileNav.classList.contains('is-open')) {
      toggleMobileNav();
    }
  });


  /* ---------- Pestañas del menú móvil ---------- */
  var navTabs = document.querySelectorAll('[data-tab]');
  if (navTabs.length) {
    navTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = this.getAttribute('data-tab');
        navTabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        document.querySelectorAll('[data-panel]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === i);
        });
      });
    });
  }

  /* ---------- Adelanto de categorías en el encabezado ---------- */
  var mega = document.querySelector('[data-megamenu]');
  var categorias = document.querySelectorAll('[data-mega-cat]');

  if (mega && categorias.length) {
    var esEscritorio = window.matchMedia('(min-width: 901px)');
    var paneles = mega.querySelectorAll('[data-mega-panel]');
    var cierreLento;

    var mostrarPanel = function (indice) {
      paneles.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-mega-panel') === indice);
      });
      categorias.forEach(function (c) {
        var activa = c.getAttribute('data-mega-cat') === indice;
        c.classList.toggle('is-active', activa);
        var a = c.querySelector('a');
        if (a) a.setAttribute('aria-expanded', String(activa));
      });
    };

    var abrirMega = function (indice) {
      if (!esEscritorio.matches) return;
      clearTimeout(cierreLento);
      if (indice !== undefined) mostrarPanel(indice);
      mega.classList.add('is-open');
    };

    var cerrarMega = function (inmediato) {
      clearTimeout(cierreLento);
      var apagar = function () {
        mega.classList.remove('is-open');
        categorias.forEach(function (c) {
          c.classList.remove('is-active');
          var a = c.querySelector('a');
          if (a) a.setAttribute('aria-expanded', 'false');
        });
      };
      if (inmediato) apagar(); else cierreLento = setTimeout(apagar, 180);
    };

    categorias.forEach(function (cat) {
      var indice = cat.getAttribute('data-mega-cat');
      cat.addEventListener('mouseenter', function () { abrirMega(indice); });
      cat.addEventListener('mouseleave', function () { cerrarMega(); });

      var enlace = cat.querySelector('a');
      if (enlace) enlace.addEventListener('focus', function () { abrirMega(indice); });
    });

    mega.addEventListener('mouseenter', function () { abrirMega(); });
    mega.addEventListener('mouseleave', function () { cerrarMega(); });

    document.addEventListener('focusin', function (e) {
      var dentro = mega.contains(e.target) ||
                   [].some.call(categorias, function (c) { return c.contains(e.target); });
      if (!dentro) cerrarMega(true);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mega.classList.contains('is-open')) cerrarMega(true);
    });

    esEscritorio.addEventListener('change', function (ev) {
      if (!ev.matches) cerrarMega(true);
    });
  }

  /* ---------- Header pegajoso ---------- */
  var header = document.querySelector('.site-header');
  if (header && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    header.parentNode.insertBefore(sentinel, header);
    new IntersectionObserver(function (entries) {
      header.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  /* ---------- Cursivas que se escriben al entrar ---------- */
  var escritos = document.querySelectorAll('.escrito');

  if (escritos.length) {
    var arrancarEscritura = function () {
      escritos.forEach(function (el) { el.classList.add('is-shown'); });
    };

    /* Esperamos a que En Clair esté cargada: si arranca antes, la letra
       cambia a media animación y no se alcanza a ver el trazo */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(arrancarEscritura);
    } else {
      requestAnimationFrame(arrancarEscritura);
    }

    /* Seguro: pase lo que pase, el texto nunca se queda invisible */
    setTimeout(arrancarEscritura, 2500);
  }

  /* ---------- Seguro para la entrada del héroe ----------
     Si la animación no llega a ejecutarse, el texto se muestra igual. */
  var blurIns = document.querySelectorAll('.blur-in');
  if (blurIns.length) {
    setTimeout(function () {
      blurIns.forEach(function (el) { el.classList.add('is-shown'); });
    }, 1200);
  }

  /* ---------- Aparición al hacer scroll ---------- */
  var revealTargets = document.querySelectorAll('.reveal');

  if (revealTargets.length && 'IntersectionObserver' in window) {
    document.querySelectorAll('.showcase__grid, .insta__grid').forEach(function (group) {
      group.querySelectorAll('.reveal').forEach(function (item, i) {
        item.style.setProperty('--reveal-delay', (i % 5) * 0.1 + 's');
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    revealTargets.forEach(function (el) { observer.observe(el); });

    /* Seguro: si algo no se marcó (pestaña oculta, observer no disparado),
       nunca dejamos texto borroso */
    setTimeout(function () {
      revealTargets.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      });
    }, 1200);
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Carrusel de Instagram ---------- */
  var instaGrid = document.querySelector('[data-insta-grid]');
  var instaNext = document.querySelector('[data-insta-next]');

  if (instaGrid && instaNext) {
    instaNext.addEventListener('click', function () {
      var first = instaGrid.querySelector('.insta__item');
      if (first) instaGrid.appendChild(first);
    });
  }

  /* ---------- Catálogo: densidad y filtrado sin recargar ---------- */
  var resultados = document.querySelector('[data-collection-results]');

  if (resultados) {
    var densityBtns = document.querySelectorAll('[data-density]');

    /* Solo hay dos densidades: amplia y compacta. El CSS traduce cada una
       al número de columnas que toca en escritorio, tableta y celular.
       Los valores viejos ('2', '3', '4') se convierten al entrar. */
    var normalizarDensidad = function (v) {
      return (v === 'amplia' || v === '2') ? 'amplia' : 'compacta';
    };

    /* Densidad: se aplica al contenedor de resultados para que sobreviva
       al reemplazo de la cuadrícula tras filtrar */
    var aplicarDensidad = function (cols) {
      cols = normalizarDensidad(cols);
      var g = resultados.querySelector('[data-collection-grid]');
      if (g) {
        g.setAttribute('data-densidad', cols);
      }
      densityBtns.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-density') === cols);
      });
    };

    aplicarDensidad(localStorage.getItem('atomico-densidad'));

    densityBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cols = this.getAttribute('data-density');
        localStorage.setItem('atomico-densidad', cols);
        aplicarDensidad(cols);
      });
    });

    /* Filtrado y orden sin recargar la página */
    var cargando = false;

    var cargar = function (url, empujarHistorial) {
      if (cargando) return;
      cargando = true;
      resultados.classList.add('collection__results--loading');

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevos = doc.querySelector('[data-collection-results]');
          if (nuevos) resultados.innerHTML = nuevos.innerHTML;

          /* Conteo y píldora activa */
          var conteoNuevo = doc.querySelector('[data-collection-count]');
          var conteo = document.querySelector('[data-collection-count]');
          if (conteoNuevo && conteo) conteo.textContent = conteoNuevo.textContent;

          var ruta = url.split('?')[0];
          document.querySelectorAll('[data-filter-link]').forEach(function (a) {
            a.classList.toggle('is-active', a.getAttribute('href').split('?')[0] === ruta);
          });

          aplicarDensidad(localStorage.getItem('atomico-densidad'));
          resultados.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });

          if (empujarHistorial) history.pushState({ url: url }, '', url);
        })
        .catch(function () { window.location.href = url; })
        .finally(function () {
          cargando = false;
          resultados.classList.remove('collection__results--loading');
        });
    };

    /* Píldoras de categoría */
    document.querySelectorAll('[data-filter-link]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        cargar(this.getAttribute('href'), true);
      });
    });

    /* Ordenamiento */
    var selectOrden = document.querySelector('[data-sort-by]');
    if (selectOrden) {
      selectOrden.addEventListener('change', function () {
        var actual = new URL(window.location.href);
        var base = [...document.querySelectorAll('[data-filter-link].is-active')][0];
        var ruta = base ? base.getAttribute('href').split('?')[0] : actual.pathname;
        var destino = new URL(ruta, window.location.origin);
        destino.searchParams.set('sort_by', this.value);
        cargar(destino.pathname + destino.search, true);
      });
    }

    window.addEventListener('popstate', function () {
      cargar(window.location.pathname + window.location.search, false);
    });
  }

  /* ---------- Galería de la ficha de producto ---------- */
  var galeria = document.querySelector('[data-pdp-gallery]');

  if (galeria) {
    var laminas = galeria.querySelectorAll('.pdp__slide');
    var miniaturas = document.querySelectorAll('[data-media-thumb]');
    var prevG = document.querySelector('[data-pdp-prev]');
    var nextG = document.querySelector('[data-pdp-next]');

    var indiceActual = function () {
      return Math.round(galeria.scrollLeft / galeria.clientWidth);
    };

    var barra = document.querySelector('[data-pdp-progress]');

    var marcar = function () {
      var i = indiceActual();
      laminas.forEach(function (l, k) { l.classList.toggle('is-active', k === i); });
      miniaturas.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
      if (prevG) prevG.disabled = i <= 0;
      if (nextG) nextG.disabled = i >= laminas.length - 1;

      /* La barrita sigue el desplazamiento real, no solo la lámina activa */
      if (barra && laminas.length > 1) {
        var recorrido = galeria.scrollWidth - galeria.clientWidth;
        var avance = recorrido > 0 ? galeria.scrollLeft / recorrido : 0;
        barra.style.transform = 'translateX(' + (avance * (laminas.length - 1) * 100) + '%)';
      }
    };

    var irA = function (i) {
      i = Math.max(0, Math.min(laminas.length - 1, i));
      galeria.scrollTo({ left: i * galeria.clientWidth, behavior: 'smooth' });
    };

    miniaturas.forEach(function (m, k) {
      m.addEventListener('click', function () { irA(k); });
    });

    if (prevG) prevG.addEventListener('click', function () { irA(indiceActual() - 1); });
    if (nextG) nextG.addEventListener('click', function () { irA(indiceActual() + 1); });

    galeria.addEventListener('scroll', marcar, { passive: true });
    window.addEventListener('resize', marcar);
    marcar();

    /* Arrastre con ratón, con detección de eje */
    galeria.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var gArrastre = false, gX = 0, gY = 0, gScroll = 0, gEje = false;

    galeria.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      gArrastre = true; gEje = false;
      gX = e.clientX; gY = e.clientY; gScroll = galeria.scrollLeft;
    });

    window.addEventListener('pointermove', function (e) {
      if (!gArrastre) return;
      var dx = e.clientX - gX, dy = e.clientY - gY;

      if (!gEje) {
        if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
        if (Math.abs(dy) > Math.abs(dx)) { gArrastre = false; return; }
        gEje = true;
        galeria.classList.add('is-dragging');
      }

      e.preventDefault();
      galeria.scrollLeft = gScroll - dx;
    });

    window.addEventListener('pointerup', function () {
      if (!gArrastre) return;
      gArrastre = false;
      galeria.classList.remove('is-dragging');
      irA(indiceActual());
    });
  }

  /* Galería antigua (otras plantillas) */
  document.querySelectorAll('.product__media [data-media-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var id = this.getAttribute('data-media-thumb');
      var raiz = this.closest('.product__media');
      if (!raiz) return;
      raiz.querySelectorAll('.product__media-item').forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-media-id') === id);
      });
      raiz.querySelectorAll('[data-media-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-thumb') === id);
      });
    });
  });

  /* ---------- Selectores de cantidad ---------- */
  document.addEventListener('click', function (e) {
    var minusBtn = e.target.closest('[data-quantity-minus]');
    var plusBtn = e.target.closest('[data-quantity-plus]');
    var input;

    if (minusBtn) {
      input = minusBtn.parentElement.querySelector('[data-quantity-input]');
      if (input) {
        var val = parseInt(input.value, 10);
        if (val > parseInt(input.min || '1', 10)) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    if (plusBtn) {
      input = plusBtn.parentElement.querySelector('[data-quantity-input]');
      if (input) {
        input.value = parseInt(input.value, 10) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });


  /* ---------- Variantes de producto ---------- */
  var productForm = document.querySelector('[data-product-form]');
  var productJson = document.querySelector('[data-product-json]');

  if (productForm && productJson) {
    var product = JSON.parse(productJson.textContent);
    var variantSelects = productForm.querySelectorAll('[data-option-index]');
    var esRadio = variantSelects.length && variantSelects[0].type === 'radio';
    var variantIdInput = productForm.querySelector('[data-variant-id]');

    var updateVariant = function () {
      var selected = [];
      if (esRadio) {
        var porIndice = {};
        variantSelects.forEach(function (input) {
          if (input.checked) porIndice[input.getAttribute('data-option-index')] = input.value;
        });
        Object.keys(porIndice).sort().forEach(function (k) { selected.push(porIndice[k]); });
      } else {
        variantSelects.forEach(function (select) { selected.push(select.value); });
      }

      var variant = product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (!variant) return;

      variantIdInput.value = variant.id;

      /* Marcar la opción elegida */
      if (esRadio) {
        variantSelects.forEach(function (input) {
          var label = input.closest('.pdp__swatch');
          if (label) label.classList.toggle('is-active', input.checked);
        });
      }

      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<span class="pdp__price-old">' + formatMoney(variant.compare_at_price) + '</span>';
          html += '<span class="pdp__price-now is-sale">' + formatMoney(variant.price) + '</span>';
        } else {
          html += '<span class="pdp__price-now">' + formatMoney(variant.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }

      var addBtn = productForm.querySelector('[data-add-to-cart]');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.toString());
      }
    };

    variantSelects.forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });
  }


  /* ---------- Compartir ---------- */
  document.querySelectorAll('[data-share-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (navigator.share) {
        navigator.share({ title: document.title, url: window.location.href });
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href).then(function () {
          var original = btn.textContent;
          btn.textContent = 'Enlace copiado';
          setTimeout(function () { btn.textContent = original; }, 2000);
        });
      }
    });
  });

  /* ---------- Direcciones de cliente ---------- */
  var newAddrToggle = document.querySelector('[data-address-toggle-new]');
  var newAddrForm = document.querySelector('[data-address-form-new]');

  if (newAddrToggle && newAddrForm) {
    newAddrToggle.addEventListener('click', function () {
      newAddrForm.style.display = newAddrForm.style.display === 'none' ? 'block' : 'none';
    });
  }

  document.querySelectorAll('[data-address-toggle-edit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.querySelector('[data-address-form-edit="' + this.getAttribute('data-address-toggle-edit') + '"]');
      if (form) form.style.display = form.style.display === 'none' ? 'block' : 'none';
    });
  });

  document.querySelectorAll('[data-address-delete]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!confirm(this.getAttribute('data-confirm') || '¿Estás seguro?')) return;
      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/account/addresses/' + this.getAttribute('data-address-delete');
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = '_method';
      input.value = 'delete';
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    });
  });

  /* ---------- Copiar código de tarjeta de regalo ---------- */
  var copyBtn = document.querySelector('[data-clipboard-target]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var target = document.querySelector(this.getAttribute('data-clipboard-target'));
      if (target && navigator.clipboard) {
        navigator.clipboard.writeText(target.value).then(function () {
          copyBtn.textContent = 'Copiado';
          setTimeout(function () { copyBtn.textContent = 'Copiar código'; }, 2000);
        });
      }
    });
  }




  /* ---------- Parallax en imágenes ----------
     Cada imagen persigue su posición objetivo con suavizado progresivo,
     en lugar de saltar a ella en cada evento de scroll. */
  var parallaxItems = document.querySelectorAll('[data-parallax]');

  if (parallaxItems.length) {
    var capas = [];

    parallaxItems.forEach(function (img) {
      capas.push({
        img: img,
        caja: img.parentElement,
        /* Recorrido corto: el movimiento se nota sin distraer */
        fuerza: img.classList.contains('showcase__image') ? 8 : 20,
        actual: 0,
        objetivo: 0
      });
    });

    var calcularObjetivos = function () {
      var vh = window.innerHeight;

      capas.forEach(function (capa) {
        var rect = capa.caja.getBoundingClientRect();

        if (rect.bottom < -300 || rect.top > vh + 300) {
          capa.visible = false;
          return;
        }
        capa.visible = true;

        var avance = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
        avance = Math.max(-1, Math.min(1, avance));
        capa.objetivo = avance * capa.fuerza;
      });
    };

    var corriendo = false;

    var animar = function () {
      var enMovimiento = false;

      capas.forEach(function (capa) {
        if (!capa.visible) return;

        var diferencia = capa.objetivo - capa.actual;

        /* Interpolación suave: cuanto menor el factor, más lento y sedoso */
        if (Math.abs(diferencia) < 0.05) {
          capa.actual = capa.objetivo;
        } else {
          capa.actual += diferencia * 0.06;
          enMovimiento = true;
        }

        capa.img.style.setProperty('--parallax', capa.actual.toFixed(2) + 'px');
      });

      /* El bucle se detiene cuando todo llegó a su sitio: no gasta batería */
      if (enMovimiento) {
        requestAnimationFrame(animar);
      } else {
        corriendo = false;
      }
    };

    var arrancar = function () {
      calcularObjetivos();
      if (!corriendo) {
        corriendo = true;
        requestAnimationFrame(animar);
      }
    };

    window.addEventListener('scroll', arrancar, { passive: true });
    window.addEventListener('resize', arrancar);
    arrancar();
  }

  /* ---------- Carrusel de la vitrina ---------- */
  var track = document.querySelector('[data-showcase-track]');

  if (track) {
    var prevBtn = document.querySelector('[data-showcase-prev]');
    var nextBtn = document.querySelector('[data-showcase-next]');

    var paso = function () {
      var card = track.querySelector('.showcase__card');
      if (!card) return track.clientWidth;
      var estilo = getComputedStyle(track);
      return card.offsetWidth + parseFloat(estilo.gap || 0);
    };

    var actualizarFlechas = function () {
      if (!prevBtn || !nextBtn) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= max;
    };

    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -paso(), behavior: 'smooth' });
    });

    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: paso(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', actualizarFlechas, { passive: true });
    window.addEventListener('resize', actualizarFlechas);
    actualizarFlechas();

    /* El navegador no debe arrastrar imágenes ni enlaces al deslizar */
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.querySelectorAll('img, a').forEach(function (el) {
      el.setAttribute('draggable', 'false');
    });

    /* Arrastrar con el ratón, para que el "swipe" también funcione en escritorio */
    var arrastrando = false, inicioX = 0, inicioY = 0, inicioScroll = 0, movido = 0, ejeDecidido = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      arrastrando = true;
      ejeDecidido = false;
      movido = 0;
      inicioX = e.clientX;
      inicioY = e.clientY;
      inicioScroll = track.scrollLeft;
    });

    window.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;

      var deltaX = e.clientX - inicioX;
      var deltaY = e.clientY - inicioY;

      /* Primero se decide el eje: si el gesto es vertical, se suelta el
         carrusel para que la página siga desplazándose con normalidad */
      if (!ejeDecidido) {
        if (Math.abs(deltaX) < 4 && Math.abs(deltaY) < 4) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          arrastrando = false;
          return;
        }
        ejeDecidido = true;
        track.classList.add('is-dragging');
      }

      e.preventDefault();
      movido = Math.abs(deltaX);
      track.scrollLeft = inicioScroll - deltaX;
    });

    window.addEventListener('pointerup', function (e) {
      if (!arrastrando) return;
      arrastrando = false;
      track.classList.remove('is-dragging');
      /* Si hubo arrastre real, evitar que se dispare el clic del enlace */
      if (movido > 8) {
        var bloquear = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
        track.addEventListener('click', bloquear, { capture: true, once: true });
      }
    });
  }

  /* ---------- Pista de swipe en la vitrina (móvil) ---------- */
  var swipeHint = document.querySelector('[data-swipe-hint]');
  var showcaseGrid = document.querySelector('.showcase__grid');

  if (swipeHint && showcaseGrid) {
    var hideHint = function () {
      swipeHint.classList.add('is-gone');
      showcaseGrid.removeEventListener('scroll', hideHint);
    };
    showcaseGrid.addEventListener('scroll', hideHint, { passive: true });
    showcaseGrid.addEventListener('touchstart', hideHint, { passive: true });
  }

  /* ---------- Cursor de estrella con aura ---------- */
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (finePointer) {
    var cursor = document.createElement('div');
    cursor.className = 'star-cursor';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.innerHTML =
      '<div class="star-cursor__glow"></div>' +
      '<svg class="star-cursor__star" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M12 0c.6 5.9 5.5 10.8 11.4 11.4v1.2C17.5 13.2 12.6 18.1 12 24c-.6-5.9-5.5-10.8-11.4-11.4v-1.2C6.5 10.8 11.4 5.9 12 0z"/>' +
      '</svg>' +
      '<span class="star-cursor__label"></span>';
    document.body.appendChild(cursor);
    document.body.classList.add('has-star-cursor');

    var mouseX = 0, mouseY = 0, curX = 0, curY = 0, started = false;

    document.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (!started) {
        curX = mouseX; curY = mouseY;
        cursor.classList.add('is-active');
        started = true;
      }
    });

    document.addEventListener('mouseleave', function () { cursor.classList.remove('is-active'); });
    document.addEventListener('mouseenter', function () { cursor.classList.add('is-active'); });

    var interactive = 'a, button, input, select, textarea, label, summary, [role="button"], [data-menu-toggle]';

    var cursorLabel = cursor.querySelector('.star-cursor__label');

    document.addEventListener('mouseover', function (e) {
      if (!e.target.closest) return;

      if (e.target.closest(interactive)) cursor.classList.add('is-hovering');

      /* Elementos que piden una etiqueta junto al cursor */
      var labelled = e.target.closest('[data-cursor-label]');
      if (labelled) {
        cursorLabel.textContent = labelled.getAttribute('data-cursor-label');
        cursor.classList.add('has-label');
      }
    });

    document.addEventListener('mouseout', function (e) {
      if (!e.target.closest) return;

      if (e.target.closest(interactive)) cursor.classList.remove('is-hovering');

      var labelled = e.target.closest('[data-cursor-label]');
      if (labelled && !labelled.contains(e.relatedTarget)) {
        cursor.classList.remove('has-label');
      }
    });

    /* Seguimiento suave: la estrella persigue al puntero con ligera inercia */
    (function follow() {
      curX += (mouseX - curX) * 0.22;
      curY += (mouseY - curY) * 0.22;
      cursor.style.left = curX + 'px';
      cursor.style.top = curY + 'px';
      requestAnimationFrame(follow);
    })();
  }


  /* ---------- Bolsa de compra ---------- */

  var contadores = document.querySelectorAll('[data-cart-count]');

  var pintarContador = function (n) {
    contadores.forEach(function (c) {
      c.textContent = n;
      c.classList.toggle('is-empty', n === 0);
      if (n > 0) {
        c.classList.remove('is-latiendo');
        void c.offsetWidth;          /* reinicia la animación */
        c.classList.add('is-latiendo');
      }
    });
  };

  var refrescarBolsa = function () {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) { pintarContador(carrito.item_count); return carrito; })
      .catch(function () { return null; });
  };

  /* Al cargar comprobamos la bolsa: las páginas se sirven en caché y el
     número podría venir desactualizado */
  if (contadores.length) refrescarBolsa();

  /* Aviso flotante al agregar */
  var avisar = function (texto, esError) {
    var previo = document.querySelector('.aviso-bolsa');
    if (previo) previo.remove();

    var aviso = document.createElement('div');
    aviso.className = 'aviso-bolsa' + (esError ? ' aviso-bolsa--error' : '');
    aviso.setAttribute('role', 'status');
    aviso.innerHTML = '<span>' + texto + '</span>' +
                      '<a href="/cart" class="aviso-bolsa__link">Ver la bolsa</a>';
    document.body.appendChild(aviso);

    requestAnimationFrame(function () { aviso.classList.add('is-open'); });
    setTimeout(function () {
      aviso.classList.remove('is-open');
      setTimeout(function () { aviso.remove(); }, 500);
    }, 4000);
  };

  /* Agregar sin salir de la página */
  var agregar = function (form, boton) {
    var textoOriginal = boton ? boton.textContent : '';
    if (boton) { boton.disabled = true; boton.textContent = 'Agregando…'; }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (datos) {
          if (!r.ok) throw new Error(datos.description || datos.message || 'No se pudo agregar');
          return datos;
        });
      })
      .then(function (linea) {
        avisar('Agregamos ' + (linea.product_title || 'la pieza') + ' a tu bolsa.');
        return refrescarBolsa();
      })
      .catch(function (e) { avisar(e.message, true); })
      .finally(function () {
        if (boton) { boton.disabled = false; boton.textContent = textoOriginal; }
      });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form], .pcard__buy')) return;
    e.preventDefault();
    agregar(form, form.querySelector('button[type="submit"]'));
  });

  /* Página de la bolsa: cantidades y quitar, sin recargar */
  var seccionCarrito = document.querySelector('[data-cart-section]');

  if (seccionCarrito) {
    var formCarrito = seccionCarrito.querySelector('[data-cart-form]');

    /* Con JavaScript las cantidades se guardan solas: el botón sale sobrando */
    var botonActualizar = seccionCarrito.querySelector('[data-cart-update]');
    if (botonActualizar) botonActualizar.hidden = true;

    var cambiarLinea = function (linea, cantidad) {
      seccionCarrito.classList.add('is-cargando');

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: linea, quantity: cantidad })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { if (formCarrito) formCarrito.submit(); });
    };

    seccionCarrito.addEventListener('click', function (e) {
      var fila = e.target.closest('[data-line]');
      if (!fila) return;
      var linea = parseInt(fila.getAttribute('data-line'), 10);
      var campo = fila.querySelector('[data-cart-qty]');

      if (e.target.closest('[data-cart-plus]')) {
        e.preventDefault();
        cambiarLinea(linea, parseInt(campo.value, 10) + 1);
      } else if (e.target.closest('[data-cart-minus]')) {
        e.preventDefault();
        cambiarLinea(linea, Math.max(0, parseInt(campo.value, 10) - 1));
      } else if (e.target.closest('[data-cart-remove]')) {
        e.preventDefault();
        cambiarLinea(linea, 0);
      }
    });

    seccionCarrito.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      var fila = e.target.closest('[data-line]');
      cambiarLinea(parseInt(fila.getAttribute('data-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }

  /* ---------- Documentos legales: índice lateral en escritorio ---------- */
  var legal = document.querySelector('[data-legal]');

  if (legal) {
    var contenido = legal.querySelector('[data-legal-content]');
    var indice = legal.querySelector('[data-legal-toc]');
    var listaIndice = legal.querySelector('[data-legal-toc-list]');
    var titulos = contenido ? contenido.querySelectorAll('h2') : [];

    /* Con menos de dos apartados el índice estorba más de lo que ayuda */
    if (titulos.length > 1) {
      indice.hidden = false;
      legal.classList.add('tiene-indice');

      titulos.forEach(function (h, i) {
        if (!h.id) h.id = 'apartado-' + (i + 1);

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent;
        a.setAttribute('data-legal-link', h.id);
        li.appendChild(a);
        listaIndice.appendChild(li);
      });

      /* Marcar el apartado que se está leyendo. Va por scroll y no por
         observador: así el resaltado nunca se queda atrás. */
      var enlaces = listaIndice.querySelectorAll('[data-legal-link]');

      var marcarApartado = function () {
        var linea = 140;   /* altura del menú fijo más un respiro */
        var actual = titulos[0];

        titulos.forEach(function (h) {
          if (h.getBoundingClientRect().top <= linea) actual = h;
        });

        enlaces.forEach(function (a) {
          a.classList.toggle('is-active', a.getAttribute('data-legal-link') === actual.id);
        });
      };

      window.addEventListener('scroll', marcarApartado, { passive: true });

      marcarApartado();
    }
  }

  /* ---------- Acordeones que se cierran con calma ----------
     El navegador quita el contenido de un <details> en cuanto se cierra,
     así que la transición de salida nunca se veía. Aquí lo retenemos. */
  var acordeones = document.querySelectorAll('.faq__item, .pdp__detail');

  acordeones.forEach(function (detalle) {
    var cabeza = detalle.querySelector('summary');
    if (!cabeza) return;

    var envoltura = detalle.querySelector('.faq__answer-wrap');
    var cerrando = false;

    cabeza.addEventListener('click', function (e) {
      e.preventDefault();
      if (cerrando) return;

      if (!detalle.open) {
        detalle.open = true;
        return;
      }

      cerrando = true;
      detalle.classList.add('is-cerrando');

      var terminar = function () {
        detalle.classList.remove('is-cerrando');
        detalle.open = false;
        cerrando = false;
      };

      /* Escuchamos la transición y dejamos un plazo por si no llega */
      var alTerminar = function (ev) {
        if (ev.propertyName !== 'grid-template-rows') return;
        envoltura.removeEventListener('transitionend', alTerminar);
        clearTimeout(plazo);
        terminar();
      };

      var plazo = setTimeout(terminar, 700);
      if (envoltura) envoltura.addEventListener('transitionend', alTerminar);
    });
  });

  /* ---------- Pop-up de suscripción ---------- */
  var popup = document.querySelector('[data-suscribe]');

  if (popup) {
    var CLAVE_POPUP = 'atomico-suscribe';
    var espera = parseInt(popup.getAttribute('data-espera'), 10) || 0;
    var dias = parseInt(popup.getAttribute('data-dias'), 10) || 30;
    var ultimoFoco = null;

    var leerEstado = function () {
      try { return JSON.parse(localStorage.getItem(CLAVE_POPUP)) || {}; }
      catch (e) { return {}; }
    };

    var guardarEstado = function (estado) {
      try { localStorage.setItem(CLAVE_POPUP, JSON.stringify(estado)); } catch (e) {}
    };

    var abrirPopup = function () {
      ultimoFoco = document.activeElement;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var campo = popup.querySelector('input[type="email"]');
      if (campo) setTimeout(function () { campo.focus(); }, 400);
    };

    var cerrarPopup = function (suscrito) {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      guardarEstado({ visto: Date.now(), suscrito: suscrito === true });
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    };

    popup.querySelectorAll('[data-suscribe-cerrar]').forEach(function (b) {
      b.addEventListener('click', function () { cerrarPopup(false); });
    });

    /* Clic fuera de la caja */
    popup.addEventListener('click', function (e) {
      if (e.target === popup) cerrarPopup(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) cerrarPopup(false);
    });

    /* Al enviar el formulario se marca como suscrito y no vuelve a salir */
    var formPopup = popup.querySelector('form');
    if (formPopup) {
      formPopup.addEventListener('submit', function () {
        guardarEstado({ visto: Date.now(), suscrito: true });
      });
    }

    /* Si Shopify devolvió el "gracias", lo mostramos aunque toque descanso */
    if (popup.querySelector('.suscribe__ok')) {
      abrirPopup();
      guardarEstado({ visto: Date.now(), suscrito: true });
    } else {
      var estado = leerEstado();
      var descanso = dias * 24 * 60 * 60 * 1000;
      var toca = !estado.suscrito && (!estado.visto || Date.now() - estado.visto > descanso);
      if (toca) setTimeout(abrirPopup, espera * 1000);
    }
  }

  /* ---------- Piezas que combinan ---------- */
  var hueco = document.querySelector('[data-combina-url]');

  if (hueco) {
    fetch(hueco.getAttribute('data-combina-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var bloque = doc.querySelector('[data-combina]');

        /* Solo cambiamos lo que ya está puesto si de veras vienen piezas */
        if (bloque && bloque.querySelector('[data-comp-add]')) {
          hueco.innerHTML = bloque.outerHTML;
          armarCombina(hueco);
        }
      })
      .catch(function () { /* si falla, la ficha se queda como estaba */ });
  }

  /* Si el bloque ya viene pintado en la página (piezas elegidas a mano),
     hay que conectarlo igual: antes solo se conectaba el que llegaba por fetch */
  document.querySelectorAll('[data-combina]').forEach(function (bloque) {
    armarCombina(bloque);
  });

  /* Los "+" y los selectores se atienden por delegación: así funcionan
     estén donde estén y aunque el bloque se pinte después. */
  function armarCombina() { /* se conserva por compatibilidad */ }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-comp-variant]');
    if (!sel) return;

    var opcion = sel.options[sel.selectedIndex];
    var ficha = sel.closest('[data-comp]');
    if (!ficha) return;

    var boton = ficha.querySelector('[data-comp-add]');
    var precio = ficha.querySelector('[data-comp-price]');

    if (boton) {
      boton.setAttribute('data-variant-id', opcion.value);
      boton.disabled = opcion.disabled;
    }
    if (precio && opcion.getAttribute('data-precio-texto')) {
      precio.textContent = opcion.getAttribute('data-precio-texto');
    }
  });

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-comp-add]');
    if (!boton || boton.disabled) return;

    e.preventDefault();

    var ficha = boton.closest('[data-comp]');
    var nombre = ficha ? ficha.querySelector('.comp__name') : null;
    var crudo = boton.getAttribute('data-variant-id');
    var id = /^\d+$/.test(crudo) ? parseInt(crudo, 10) : crudo;

    boton.disabled = true;
    if (ficha) ficha.classList.add('is-agregando');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'No se pudo agregar');
          return d;
        });
      })
      .then(function () {
        if (ficha) {
          ficha.classList.remove('is-agregando');
          ficha.classList.add('is-agregado');
        }
        avisar('Agregamos ' + (nombre ? nombre.textContent.trim() : 'la pieza') + ' a tu bolsa.');
        refrescarBolsa();

        /* En la bolsa conviene refrescar para ver la pieza ya sumada */
        if (document.querySelector('[data-cart-section]')) {
          setTimeout(function () { window.location.reload(); }, 900);
          return;
        }

        setTimeout(function () {
          if (ficha) ficha.classList.remove('is-agregado');
          boton.disabled = false;
        }, 2200);
      })
      .catch(function (err) {
        if (ficha) ficha.classList.remove('is-agregando');
        boton.disabled = false;
        avisar(err.message, true);
      });
  });

  /* ---------- Buscador ---------- */

  var panelBusqueda = document.querySelector('[data-search-panel]');

  if (panelBusqueda) {
    var campoBusqueda = panelBusqueda.querySelector('[data-search-input]');
    var resultadosBusqueda = panelBusqueda.querySelector('[data-search-results]');
    var veloBusqueda = document.querySelector('[data-search-overlay]');
    var temporizador;

    var abrirBusqueda = function (e) {
      if (e) e.preventDefault();
      panelBusqueda.classList.add('is-open');
      panelBusqueda.setAttribute('aria-hidden', 'false');
      if (veloBusqueda) veloBusqueda.classList.add('is-open');
      setTimeout(function () { campoBusqueda.focus(); }, 120);
    };

    var cerrarBusqueda = function () {
      panelBusqueda.classList.remove('is-open');
      panelBusqueda.setAttribute('aria-hidden', 'true');
      if (veloBusqueda) veloBusqueda.classList.remove('is-open');
    };

    document.querySelectorAll('[data-search-toggle]').forEach(function (b) {
      b.addEventListener('click', abrirBusqueda);
    });

    var botonCerrar = panelBusqueda.querySelector('[data-search-close]');
    if (botonCerrar) botonCerrar.addEventListener('click', cerrarBusqueda);
    if (veloBusqueda) veloBusqueda.addEventListener('click', cerrarBusqueda);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panelBusqueda.classList.contains('is-open')) cerrarBusqueda();
    });

    /* La ruta de resultados la toma del formulario: así funciona igual
       en Shopify (/search) que en la vista previa */
    var rutaBusqueda = function () {
      var f = panelBusqueda.querySelector('form');
      return (f && f.getAttribute('action')) || '/search';
    };

    var sugeridos = panelBusqueda.querySelector('[data-search-fallback]');

    var mostrarSugeridos = function (visible) {
      if (sugeridos) sugeridos.hidden = !visible;
    };

    var pintarResultados = function (productos, termino) {
      if (!productos.length) {
        resultadosBusqueda.innerHTML =
          '<p class="busqueda-panel__vacio">No encontramos nada para «' + termino + '». ' +
          'Estas piezas quizá te gusten:</p>';
        mostrarSugeridos(true);
        return;
      }

      mostrarSugeridos(false);

      resultadosBusqueda.innerHTML =
        '<ul class="busqueda-panel__lista">' +
        productos.map(function (p) {
          var foto = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url + '" alt="" width="60" height="60" loading="lazy">'
            : '<span class="ph"></span>';
          return '<li><a href="' + p.url + '" class="bres">' +
                 '<span class="bres__media">' + foto + '</span>' +
                 '<span class="bres__texto">' +
                 '<span class="bres__nombre">' + p.title + '</span>' +
                 '<span class="bres__precio">' + p.price + '</span>' +
                 '</span></a></li>';
        }).join('') +
        '</ul>' +
        '<a href="' + rutaBusqueda() + '?q=' + encodeURIComponent(termino) + '&type=product" class="busqueda-panel__todos">' +
        'Ver todos los resultados</a>';
    };

    /* Cada búsqueda lleva número. Solo pintamos la respuesta de la última
       consulta lanzada: si una vieja llega tarde, se descarta. Sin esto los
       resultados se quedaban un paso atrás de lo que se escribe. */
    var consultaNumero = 0;
    var peticionEnCurso = null;

    var buscar = function (termino) {
      var miNumero = ++consultaNumero;

      if (peticionEnCurso) peticionEnCurso.abort();
      peticionEnCurso = ('AbortController' in window) ? new AbortController() : null;

      fetch('/search/suggest.json?q=' + encodeURIComponent(termino) +
            '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
            {
              headers: { 'Accept': 'application/json' },
              signal: peticionEnCurso ? peticionEnCurso.signal : undefined
            })
        .then(function (r) { return r.json(); })
        .then(function (datos) {
          if (miNumero !== consultaNumero) return;                 /* llegó tarde */
          if (campoBusqueda.value.trim() !== termino) return;       /* ya se escribió otra cosa */

          var productos = (datos.resources && datos.resources.results && datos.resources.results.products) || [];
          pintarResultados(productos, termino);
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          if (miNumero !== consultaNumero) return;
          resultadosBusqueda.innerHTML = '<p class="busqueda-panel__vacio">No pudimos buscar en este momento.</p>';
          mostrarSugeridos(true);
        });
    };

    campoBusqueda.addEventListener('input', function () {
      var termino = this.value.trim();
      clearTimeout(temporizador);

      if (termino.length < 2) {
        consultaNumero++;                       /* invalida lo que venga en camino */
        if (peticionEnCurso) peticionEnCurso.abort();
        resultadosBusqueda.innerHTML = '';
        mostrarSugeridos(true);                 /* el panel nunca queda vacío */
        return;
      }

      temporizador = setTimeout(function () { buscar(termino); }, 250);
    });
  }

  /* ---------- Lista de deseos ----------
     Vive en el navegador de cada persona; no se comparte entre equipos. */
  var CLAVE_DESEOS = 'atomico-deseos';

  var leerDeseos = function () {
    try { return JSON.parse(localStorage.getItem(CLAVE_DESEOS)) || []; }
    catch (e) { return []; }
  };

  var guardarDeseos = function (lista) {
    try { localStorage.setItem(CLAVE_DESEOS, JSON.stringify(lista)); } catch (e) {}
  };

  var pintarContadorDeseos = function () {
    var n = leerDeseos().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (c) {
      c.textContent = n;
      c.classList.toggle('is-empty', n === 0);
    });
  };

  var marcarBotonesDeseo = function () {
    var lista = leerDeseos();
    document.querySelectorAll('[data-deseo]').forEach(function (b) {
      var guardado = lista.indexOf(b.getAttribute('data-deseo-handle')) !== -1;
      b.classList.toggle('is-guardado', guardado);
      b.setAttribute('aria-pressed', String(guardado));

      var texto = b.querySelector('[data-deseo-texto]');
      if (!texto) return;

      /* El de la página de la lista siempre dice "Quitar" */
      if (b.classList.contains('deseo--quitar')) {
        texto.textContent = 'Quitar';
      } else if (b.classList.contains('deseo--ficha')) {
        texto.textContent = guardado ? 'En tu lista' : 'Avísame';
      } else {
        texto.textContent = guardado ? 'Guardada en tu lista' : 'Guardar en mi lista de deseos';
      }
    });
  };

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-deseo]');
    if (!boton) return;

    e.preventDefault();
    var handle = boton.getAttribute('data-deseo-handle');
    var lista = leerDeseos();
    var i = lista.indexOf(handle);

    if (i === -1) { lista.unshift(handle); } else { lista.splice(i, 1); }

    guardarDeseos(lista.slice(0, 50));
    marcarBotonesDeseo();
    pintarContadorDeseos();

    /* En la propia página de la lista, quitar saca la ficha de la vista */
    var enLista = boton.closest('[data-wishlist-item]');
    if (enLista && i !== -1) { enLista.remove(); revisarListaVacia(); }
  });

  pintarContadorDeseos();
  marcarBotonesDeseo();

  /* Página de la lista */
  var rejillaDeseos = document.querySelector('[data-wishlist-grid]');

  function revisarListaVacia() {
    if (!rejillaDeseos) return;
    var vacio = document.querySelector('[data-wishlist-empty]');
    var conteo = document.querySelector('[data-wishlist-count-text]');
    var cuantas = rejillaDeseos.querySelectorAll('[data-wishlist-item]').length;

    if (vacio) vacio.hidden = cuantas > 0;
    if (conteo) conteo.textContent = cuantas === 1 ? '1 pieza' : cuantas + ' piezas';
  }

  if (rejillaDeseos) {
    var handles = leerDeseos();

    if (!handles.length) {
      revisarListaVacia();
    } else {
      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + handle + '?view=mini')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (piezas) {
        var vivos = [];

        piezas.forEach(function (html, i) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ficha = doc.querySelector('.pmini');
          if (!ficha) return;

          ficha.setAttribute('data-wishlist-item', handles[i]);

          var quitar = document.createElement('button');
          quitar.type = 'button';
          quitar.className = 'deseo deseo--quitar';
          quitar.setAttribute('data-deseo', '');
          quitar.setAttribute('data-deseo-handle', handles[i]);
          quitar.innerHTML = '<span class="deseo__texto" data-deseo-texto>Quitar</span>';
          ficha.appendChild(quitar);

          vivos.push(ficha.outerHTML);
        });

        rejillaDeseos.innerHTML = vivos.join('');
        rejillaDeseos.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
        marcarBotonesDeseo();
        revisarListaVacia();
      });
    }
  }

  /* ---------- Vistos recientemente ---------- */
  var CLAVE_VISTOS = 'atomico-vistos';

  var leerVistos = function () {
    try { return JSON.parse(localStorage.getItem(CLAVE_VISTOS)) || []; }
    catch (e) { return []; }
  };

  /* Registrar el producto actual */
  var contenedorRel = document.querySelector('[data-related-mode]');
  var handleActual = contenedorRel && contenedorRel.getAttribute('data-product-handle');

  if (handleActual) {
    var vistos = leerVistos().filter(function (h) { return h !== handleActual; });
    vistos.unshift(handleActual);
    try { localStorage.setItem(CLAVE_VISTOS, JSON.stringify(vistos.slice(0, 12))); } catch (e) {}
  }

  /* Pintar la tira de vistos recientemente */
  var recentGrid = document.querySelector('[data-recent-grid]');

  if (recentGrid) {
    var envoltura = document.querySelector('[data-recent-wrap]');
    var lista = leerVistos().filter(function (h) { return h !== handleActual; }).slice(0, 4);

    if (lista.length) {
      Promise.all(lista.map(function (handle) {
        return fetch('/products/' + handle + '?view=mini')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (piezas) {
        /* Sacamos solo las fichas: si una respuesta trae de más, se descarta */
        var fichas = [];

        piezas.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var ficha = doc.querySelector('.pmini');
          if (ficha) fichas.push(ficha.outerHTML);
        });

        if (!fichas.length) return;

        recentGrid.innerHTML = fichas.join('');
        if (envoltura) envoltura.classList.remove('is-hidden');
        recentGrid.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      });
    }
  }

  /* Sugerencias automáticas de Shopify */
  var relAuto = document.querySelector('[data-related-url]');
  if (relAuto) {
    fetch(relAuto.getAttribute('data-related-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var contenido = doc.querySelector('.related__card');

        /* Sin piezas dentro no vale la pena mostrar la sección */
        if (contenido && contenido.querySelector('.pmini')) {
          relAuto.innerHTML = contenido.outerHTML;
          relAuto.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
        }
      })
      .catch(function () {});
  }

  /* ---------- Utilidad: formato de moneda ---------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
})();
